import { Alert, Box, Chip, Typography } from '@mui/material';
import { AnyObject } from 'yup';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';

interface WarnedItem {
  items: (AnyObject & { id: string; name: string })[];
  chipOnClick?: (id: string) => void;
}

interface DeleteWarningBaseProps {
  warningText?: string;
  warnedChilds?: {
    // key is a label of entities group and value is an array of entities
    [label: string]: WarnedItem;
  };
}

export const DeleteWarningBase: React.FC<DeleteWarningBaseProps> = ({
  warnedChilds,
  warningText,
}) => {
  const { t } = useTranslation();
  const defaultTitle = t(
    'Check dependant items before deleting this item. This action is irreversible.',
    { ns: 'common' }
  );
  if (!warningText && !warnedChilds) {
    return (
      <Alert variant='filled' severity='warning'>
        {defaultTitle}
      </Alert>
    );
  }
  const content = () => {
    const groupsWithItems = Object.entries(warnedChilds || {}).filter(
      ([, { items }]) => !!items.length
    );

    const GroupChips = ({ items, chipOnClick }: WarnedItem) => {
      return (
        <>
          {items.slice(0, 10).map((value) => (
            <Chip
              onClick={chipOnClick ? () => chipOnClick(value.id) : undefined}
              key={value.id}
              label={value.name}
            />
          ))}
          {items.length > 10 && <Chip label={`+${items.length - 10} more`} />}
        </>
      );
    };

    return (
      <Box>
        {groupsWithItems.map(([groupLabel, groupValues]) => (
          <Box key={groupLabel} sx={{ mt: 1 }}>
            <Typography>{groupLabel}:</Typography>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1rem',
                flexDirection: 'row',
              }}
            >
              {GroupChips(groupValues)}
            </Box>
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Alert
        sx={{
          width: '100%',
          borderRadius: (theme) => theme.borderRadius.primary,
        }}
        variant='filled'
        severity='warning'
      >
        <Typography>{warningText || defaultTitle}</Typography>
        {content()}
      </Alert>
    </Box>
  );
};
